import { Col, Input, Checkbox, Button, Row, Progress } from 'antd'
import React from 'react'
import moment from 'moment'
import Modal from '../../component/modal'
import Axios from 'axios'

// interface IProps {
//     district: string[]
//     platform: string
//     contains: string
//     command: string
//     mins: number
//     times: number
//     devices: any[]
//     retry: string
//     timeNeed: string
//     note: string
//     // for ui
//     _key: string

//     /**
//      * batch
//      */
//     status?: string
//     nowIndex?: number
//     _id?: string
//     nextRunTime?: Date
//     lastRunTime?: Date

//     index: number
//     remove: (key: string) => void
//     update: (index: number, value: any) => void
// }

const styles = {
    th: {
        backgroundColor: '#fafafa',
        padding: '16px 24px',
        borderRight: '1px solid #e8e8e8',
    },
    td: {
        padding: '16px 24px',
    },
    tr: {
        borderBottom: '1px solid #e8e8e8',
    },
}

const Component = React.forwardRef<any, any>((props, ref) => {
    const [state, setState] = React.useState({
        ...props,
    })

    React.useImperativeHandle(ref, () => ({
        setIndex(value: number) {
            setState((prev: any) => ({
                ...prev,
                nowIndex: value,
            }))
        },
    }))

    const onInputChange = (evt: any) => {
        const value = evt.target.value
        setState({
            ...state,
            district: value.split(','),
        })
    }

    const onTick = (e: any) => {
        const value = e.target.value
        setState({
            ...state,
            platform: state.platform !== value ? value : '',
        })
    }

    const onChange = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
        setState({
            ...state,
            [key]: e.target.value,
        })
    }

    const onApply = () => {
        const { contains, platform, district } = state
        Axios.get('/devices', {
            params: {
                contains,
                platform,
                district,
            },
        }).then((res) => {
            setState((prev: any) => ({
                ...prev,
                devices: res.data,
            }))
        })
    }

    const toHour = (times: any, mins: any) => {
        const totalSecond = times * (mins * 60)
        const totalHour = Math.floor(totalSecond / 3600)
        const totalMins = (totalSecond % 3600) / 60
        return `${totalHour} hrs ${totalMins} mins`
    }

    const onSubmit = async () => {
        Axios.post('/batch', {
            times: state.times,
            mins: state.mins,
            devices: state.devices,
            command: state.command,
            district: (state.district || []).length <= 0 ? '' : state.district.join(','),
            platform: state.platform,
            contains: state.contains,
        })
            .then((res) => {
                const batch = res.data
                batch._key = state._key
                // if (batch.district) batch.district = batch.district.split(',')
                props.update(props.index, batch)
                setState({ ...batch })
            })
            .catch((err) => console.error)
    }

    return (
        <Col span={12}>
            <div
                style={{
                    textAlign: 'left',
                    maxWidth: '400px',
                }}
            >
                <table cellPadding={5} style={{ width: '100%' }}>
                    <tbody>
                        <tr>
                            <td>District</td>
                            <td>
                                <Input
                                    placeholder="Select district"
                                    // mode="multiple"
                                    onChange={onInputChange}
                                    style={{ width: '100%' }}
                                    value={state.district}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>Platform</td>
                            <td>
                                <Checkbox
                                    value="lora"
                                    onChange={onTick}
                                    checked={(state.platform || '').toLocaleLowerCase() === 'lora'}
                                >
                                    Lora
                                </Checkbox>
                                <Checkbox
                                    value="onenet"
                                    onChange={onTick}
                                    checked={(state.platform || '').toLocaleLowerCase() === 'onenet'}
                                >
                                    Onenet
                                </Checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td>Sensor ID Contains</td>
                            <td>
                                <Input
                                    style={{ maxWidth: 300 }}
                                    value={state.contains}
                                    onChange={(e) => {
                                        onChange(e, 'contains')
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>Command</td>
                            <td>
                                <Input
                                    style={{ maxWidth: 300 }}
                                    value={state.command}
                                    onChange={(e) => {
                                        onChange(e, 'command')
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>Retry</td>
                            <td>
                                after
                                <Input
                                    style={{ maxWidth: 50 }}
                                    value={state.mins}
                                    onChange={(e) => {
                                        onChange(e, 'mins')
                                    }}
                                />
                                mins, for{' '}
                                <Input
                                    style={{ maxWidth: 50 }}
                                    value={state.times}
                                    onChange={(e) => {
                                        onChange(e, 'times')
                                    }}
                                />{' '}
                                times
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                <Button type="primary" style={{ width: '100%' }} onClick={onApply}>
                                    Apply
                                </Button>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div style={{ border: '1px solid #e8e8e8', marginTop: '40px' }}>
                    <table style={{ width: '100%' }}>
                        <tbody>
                            <tr style={styles.tr}>
                                <th style={styles.th}>Selected sensor</th>
                                <td style={styles.td} align="right">
                                    <span style={{ float: 'left' }}>
                                        {state.devices.length > 0 ? state.devices.length : '-'}
                                    </span>

                                    <Modal devices={state.devices} />
                                </td>
                            </tr>
                            <tr style={styles.tr}>
                                <th style={styles.th}>Retry for</th>
                                <td style={styles.td}>{state.times}</td>
                            </tr>
                            <tr style={styles.tr}>
                                <th style={styles.th}>Time needed</th>
                                <td style={styles.td}>{toHour(Number(state.times), Number(state.mins))}</td>
                            </tr>
                        </tbody>
                    </table>
                    <Button
                        type="primary"
                        style={{
                            width: '100%',
                            marginTop: '10px',
                        }}
                        onClick={onSubmit}
                    >
                        Upload
                    </Button>
                </div>

                {state.nowIndex && state.mins && state.status === 'processing' ? (
                    <div>
                        <Row style={{ marginTop: '40px', display: 'flex' }} justify="center">
                            <Col span={12} style={{ textAlign: 'center' }}>
                                <Progress
                                    type="circle"
                                    strokeColor={{
                                        '0%': '#108ee9',
                                        '100%': '#87d068',
                                    }}
                                    percent={(state.nowIndex / state.times) * 100}
                                    format={(percent) => `${state.nowIndex} / ${state.times}`}
                                />
                            </Col>
                            <Col span={12} style={{ textAlign: 'center' }}>
                                <div>Retry At</div>
                                <div
                                    style={{
                                        fontSize: '25px',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    {moment(state.nextRunTime).format('HH:mm:ss')}
                                </div>
                                <div>{moment(state.nextRunTime).format('YYYY-MM-DD')}</div>
                            </Col>
                        </Row>

                        <Button
                            type="primary"
                            style={{ width: '100%', marginTop: '10px' }}
                            onClick={() => {
                                props.remove(state._id!)
                            }}
                        >
                            Stop
                        </Button>
                    </div>
                ) : null}
            </div>
        </Col>
    )
})

export default Component
